import {askStudyNotes} from './research'
import {listConnected,putConnected} from './connectedLearningStore'

type Context={id:string;title:string;text:string;kind?:'study_note'|'reflection'}
type Answer={answer:string;sourceIds:string[]}
const VERSION='connected-haiku-v1'
const inflight=new Map<string,Promise<Answer>>()
async function sha256(value:string):Promise<string>{
 const bytes=new TextEncoder().encode(value)
 const digest=await crypto.subtle.digest('SHA-256',bytes)
 return Array.from(new Uint8Array(digest),b=>b.toString(16).padStart(2,'0')).join('')
}
/** Only call from an explicit user action. Cache lookup must succeed before requesting AI. */
export async function askConnectedHaiku(operation:string,prompt:string,contexts:Context[]):Promise<Answer>{
 const signature=await sha256(JSON.stringify({version:VERSION,operation,prompt,contexts:contexts.map(c=>({id:c.id,title:c.title,text:c.text,kind:c.kind}))}))
 const key=operation+':'+signature
 const running=inflight.get(key)
 if(running)return running
 const task=(async()=>{
  const records=await listConnected('analysis-cache')
  const cached=records.find(r=>r.record_key===key)?.payload as Answer|undefined
  if(cached && typeof cached.answer==='string' && Array.isArray(cached.sourceIds))return cached
  const result=await askStudyNotes(prompt,contexts)
  if(!result.answer?.trim())throw new Error('AI returned an empty response. Nothing was cached.')
  await putConnected('analysis-cache',key,result)
  return result
 })()
 inflight.set(key,task)
 try{return await task}finally{inflight.delete(key)}
}
